// 全局上移动画
import {useEffect} from 'preact/hooks';
import {throttle} from 'lodash';
import {isMobile} from '~/utils';
export const useGlobalMoveAnimation = (source = 'qf') => {
    const moduleTitleClassName = `${source}-module-title`;
    const moduleDescClassName = `${source}-module-des`;
    const moduleContentClassName = `${source}-module-content`;

    /** 判断是否在视窗下方 */
    const isBelowViewport = element => {
        if (!element) {
            return false;
        }
        const rect = element.getBoundingClientRect();
        return rect.top > window.innerHeight;
    };

    useEffect(() => {
        const titleList = document.querySelectorAll(`.${moduleTitleClassName}`);
        const descList = document.querySelectorAll(`.${moduleDescClassName}`);
        const contentList = document.querySelectorAll(`.${moduleContentClassName}`);

        const nodeList = [...titleList, ...descList, ...contentList];
        // 实现视窗下模块动画展示效果
        const handleAnimationEffect = () => {
            if (isMobile()) {
                nodeList.forEach(item => {
                    item.classList.remove('below-module');
                });
                return;
            }
            if (nodeList.length) {
                nodeList.forEach(item => {
                    if (isBelowViewport(item)) {
                        item.classList.add('below-module');
                    } else {
                        item.classList.remove('below-module');
                    }
                });
            }
        };
        const throttleHandleAnimationEffect = throttle(handleAnimationEffect, 100);
        window.addEventListener('scroll', throttleHandleAnimationEffect);
        window.addEventListener('resize', throttleHandleAnimationEffect);
        return () => {
            window.removeEventListener('scroll', throttleHandleAnimationEffect);
            window.removeEventListener('resize', throttleHandleAnimationEffect);
        };
    }, []);
};
